import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SharedOperationsService } from '../services/shared-operations.service';

@Injectable({ providedIn: 'root' })
export class accountGuard  {
    constructor(
        private router: Router,
        private sharedOperationsService: SharedOperationsService,
    ) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.sharedOperationsService.getAuthenticatedUser();
        if (currentUser) {
            this.router.navigate(['/projects'], { queryParams: { returnUrl: state.url } });
            return false;
        }
        return true;
    }
}
